<template>
    <nav class="bg-black">
        <div class="flex flex-wrap items-center justify-between p-4 px-8">
            <Link :href="route('bookings.home')" class="flex items-center space-x-3 rtl:space-x-reverse">
                <ApplicationMark class="block h-12 md:h-[5rem] w-auto"/>
            </Link>

            <div>
                <button
                    class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-primary-600 hover:text-black focus:outline-hidden focus:ring-2 focus:ring-gray-200"
                    type="button"
                    @click="showingNavigationDropdown = !showingNavigationDropdown"
                >
                    <span class="sr-only">Open main menu</span>
                    <svg
                        aria-hidden="true"
                        class="w-5 h-5"
                        fill="none"
                        viewBox="0 0 17 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1 1h15M1 7h15M1 13h15"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </svg>
                </button>
            </div>

            <div
                :class="{
                    'hidden md:block md:w-auto': !showingNavigationDropdown,
                    'md:block md:w-auto': showingNavigationDropdown,
                }"
                class="w-full"
            >
                <ul
                    class="font-medium whitespace-nowrap flex items-center flex-col p-4 md:p-0 mt-4 rounded-lg bg-black md:flex-row gap-4 rtl:space-x-reverse md:mt-0"
                >
                    <li class="w-full">
                        <Link
                            :href="route('bookings.home')"
                            class="block w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black md:hover:bg-transparent md:border-0 md:hover:text-primary-700 md:p-4"
                        >
                            Home
                        </Link>
                    </li>
                    <li class="w-full">
                        <Link
                            :href="route('bookings.event.view')"
                            class="block w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black md:hover:bg-transparent md:border-0 md:hover:text-primary-700 md:p-4"
                        >
                            Events
                        </Link>
                    </li>
                    <li v-if="$page.props.auth.logged_in" class="w-full">
                        <Link
                            :href="route('my-bookings')"
                            class="block w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black md:hover:bg-transparent md:border-0 md:hover:text-primary-700 md:p-4"
                        >
                            My Bookings
                        </Link>
                    </li>
                    <li v-if="$page.props.auth.logged_in" class="w-full">
                        <Link
                            :href="route('booking.tournaments.index')"
                            class="block w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black md:hover:bg-transparent md:border-0 md:hover:text-primary-700 md:p-4"
                        >
                            My Tournaments
                        </Link>
                    </li>
                    <li class="w-full">
                        <span
                            class="block w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black md:hover:bg-transparent md:border-0 md:hover:text-primary-700 md:p-4 cursor-pointer"
                            @click="openInTab(subscriptionsUrl)"
                        >
                            Subscriptions
                        </span>
                    </li>
                    <li class="w-full">
                        <a
                            class="block w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black md:hover:bg-transparent md:border-0 md:hover:text-primary-700 md:p-4"
                            href="https://thenerdhut.co.uk"
                        >
                            Store
                        </a>
                    </li>
                    <li v-if="!$page.props.auth.logged_in" class="w-full">
                        <Link
                            :href="route('login')"
                            class="block w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black md:hover:bg-transparent md:border-0 md:hover:text-primary-700 md:p-4"
                        >
                            Login
                        </Link>
                    </li>
                    <li v-if="!$page.props.auth.logged_in" class="w-full">
                        <Link
                            :href="route('register')"
                            class="block w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black md:hover:bg-transparent md:border-0 md:hover:text-primary-700 md:p-4"
                        >
                            Register
                        </Link>
                    </li>

                    <UserDropdown/>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script setup>
    import ApplicationMark from "../../InertiaComponents/ApplicationMark.vue";
    import { ref } from "vue";
    import { Link, router } from "@inertiajs/vue3";
    import UserDropdown from "@/Layouts/common/UserDropdown.vue";

    const showingNavigationDropdown = ref(false);
    const subscriptionsUrl = import.meta.env.VITE_SUBSCRIPTIONS_APP_URL;

    const logout = () => {
        router.post(
            route("logout"),
            {},
            {
                onFinish: () => {
                    window.location.reload();
                },
            },
        );
    };

    const openInTab = (url) => {
        window.location.href = url;
    };
</script>
